import React from 'react';
import MetafieldDefinitionsPage from './MetafieldDefinitionsPage';

export default function ProductMetafields() {
  return (
    <MetafieldDefinitionsPage
      ownerType="PRODUCT"
      title="Product Metafields"
      routePrefix="/metafields/product"
    />
  );
}
